import ShortcutLayout from '@/shortcut-layout';
import Layout from '@/layout';
import i18n from '@/utils/i18n';
/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export default [
  {
    path: '/login/index',
    name: 'Login',
    component: () => import('@/views/login/index'),
    meta: { title: '登录', navMenu: 'Login' },
    hidden: true,
  },
  {
    path: '/login/easewinIndex',
    name: 'Login',
    component: () => import('@/views/login/easewinIndex'),
    meta: { title: '登录', navMenu: 'Login' },
    hidden: true,
  },
  {
    path: '/login/cashier',
    name: 'FoodCashierLogin',
    component: () => import('@/views/login/foodLogin'),
    meta: { title: 'Food Cashier Login', navMenu: 'Login', system: 'cashier' },
    hidden: true,
  },
  {
    path: '/login/shop',
    name: 'FoodShopLogin',
    component: () => import('@/views/login/foodLogin'),
    meta: { title: 'Food Shop Login', navMenu: 'Login', system: 'shop' },
    hidden: true,
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404'),
    meta: { title: '404', navMenu: '404' },
    hidden: true,
  },
  {
    path: '/articleDetail/index',
    meta: { title: '文章详情/预览' },
    component: () => import('@/components/articleDetail'),
    hidden: true,
  },
  {
    path: '/sellCard/index',
    meta: { title: '售卡排行榜' },
    component: () => import('@/components/sellCard'),
    hidden: true,
  },
  // {
  //   path: '/memberH5/index',
  //   meta: { title: '赚钱技巧' },
  //   component: () => import('@/components/memberH5'),
  //   hidden: true,
  // },
  // {
  //   path: '/memberH5Suggest/index',
  //   meta: { title: '会员宣导反馈建议' },
  //   component: () => import('@/components/memberH5Suggest'),
  //   hidden: true,
  // },
  {
    path: '/publicNotice/*',
    meta: { title: '公告栏' },
    component: () => import('@/components/announcement'),
    hidden: true,
  },
  {
    path: '/common/price-card',
    meta: { title: '房价牌' },
    component: () => import('@/views/common/price-card'),
    hidden: true,
  }, // 日志
  {
    path: '/operate-log',
    component: ShortcutLayout,
    redirect: '/operate-log/business',
    name: 'Log',
    meta: { title: '日志', navMenu: 'Log' },
    children: [
      {
        path: '/operate-log/business',
        meta: {
          get title() {
            return i18n.t('route.businessLog');
          },
          navMenu: 'Log',
        },
        component: () => import('@/views/operateLog/workingDay'),
      },
      {
        path: '/operate-log/nightAuditLog',
        meta: {
          get title() {
            return i18n.t('route.nightAuditLog');
          },
          navMenu: 'Log',
        },
        component: () => import('@/views/operateLog/nightAuditLog'),
      },
    ],
  },
  {
    path: '/serviceManage',
    meta: { title: '系统消息' },
    component: () => import('@/views/notice/serviceManage'),
    hidden: true,
  },
  {
    path: '/orderBox',
    component: Layout,
    redirect: '/orderBox/index',
    name: 'OrderBoxShortcut',
    meta: {
      get title() {
        return i18n.t('orderBoxIndex.title');
      },
    },
    hidden: true,
    children: [
      {
        path: '/orderBox/index',
        name: 'OrderBoxIndex',
        component: () => import('@/views/guest/order-box/index'),
        meta: {
          get title() {
            return i18n.t('orderBoxIndex.title');
          },
          navMenu: 'Guest',
        },
      },
    ],
  },
];
